import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowLeft, FileDown, X } from 'lucide-react';
import { Button } from '../../../components/ui/button';
// import { toast } from 'react-hot-toast';

interface BrandbookHeaderProps {
  title?: string;
  onExport?: () => void;
  onSaveClick?: () => void; // Changed from onSave to onSaveClick for clarity
  viewOnly?: boolean;
  isLoading?: boolean; // Add loading state prop
}

export function BrandbookHeader({
  title,
  // onExport,
  onSaveClick,
  viewOnly = false,
  isLoading = false,
}: BrandbookHeaderProps) {
  const navigate = useNavigate();
  // const [isExporting, setIsExporting] = useState('Export');
  const [showNotification, setShowNotification] = useState(true);

  const handleBack = () => {
    navigate('/brandbook/get-started');
  };

  // const handleCopy = async () => {
  //   try {
  //     const content = document.querySelector('.bg-white.p-8')?.textContent;
  //     if (content) {
  //       await navigator.clipboard.writeText(content);
  //       toast.success('Content copied to clipboard');
  //     }
  //   } catch (error) {
  //     console.error('Copy failed:', error);
  //     toast.error('Failed to copy content');
  //   }
  // };

  // const handleExport = async () => {
  //   setIsExporting('Exporting...');
  //   try {
  //     if (onExport) {
  //       await onExport();
  //     }
  //     setIsExporting('Export');
  //   } catch (error) {
  //     console.error('Export failed:', error);
  //     toast.error('Export failed');
  //     setIsExporting('Export');
  //   }
  // };

  return (
    <div className="flex flex-col bg-background-main text-text-primary rounded-t-md w-full">
      <header className="border-b px-4">
        <div className="h-14 flex items-center justify-between">
          <div className="flex items-center gap-2">
            <Button
              variant="ghost"
              size="icon"
              onClick={handleBack}
              className="mr-2"
            >
              <ArrowLeft className="h-4 w-4 text-primary" />
            </Button>
            <h1 className=" text-lg">Brandbook {title ? `/ ${title}` : ''}</h1>
          </div>

          <div className="items-center gap-2 hidden lg:flex">
            {/* <Button
              variant="ghost"
              size="sm"
              onClick={handleCopy}
              className="text-violet-600"
            >
              <Copy className="h-4 w-4 mr-2" />
            </Button> */}

            <div className="relative inline-block">
              {/* Coming Soon Badge */}
              <div className="absolute  bg-blue-600 text-white px-1 py-1 rounded-full text-[6px] -right-2 z-10 -top-2 font-medium whitespace-nowrap">
                Coming Soon
              </div>

              <Button
                variant="ghost"
                size="sm"
                // onClick={handleExport}
                // disabled={isExporting !== 'Export'}
                disabled={true}
                className="text-primary text-sm disabled:cursor-not-allowed disabled:bg-gray-400 disabled:text-black 
        disabled:hover:text-black flex items-center"
              >
                <FileDown className="h-4 w-4 mr-1" />
                {/* {isExporting} */}
                Export
              </Button>
            </div>

            {!viewOnly && (
              <Button
                variant="customSecondary"
                size="sm"
                onClick={onSaveClick}
                disabled={isLoading}
                className="bg-secondary"
              >
                {isLoading ? 'Saving...' : 'Save'}
              </Button>
            )}
          </div>
        </div>
      </header>
      {showNotification && (
        <div className="bg-emerald-600 text-white px-4 py-2 flex justify-between items-center">
          <p>
            Slogan, values, vision, voice, logo and colour palette, all
            generated in one click. Now you can edit them individually to fit
            your brand perfectly!
          </p>
          <button
            onClick={() => setShowNotification(false)}
            className="text-white hover:text-gray-200"
          >
            <X className="h-4 w-4" />
          </button>
        </div>
      )}
    </div>
  );
}

export default BrandbookHeader;
